



















































// import moment from 'moment'
import dayjs from 'dayjs'
import AvailableDates from '../common/dates'
import store from '../store'
import { Vue, Component } from "vue-property-decorator";
import { cleanDate } from '@/filters/filters';

const DatePickerProps = Vue.extend({
  props: {
    originalDate: String,
    label: String,
    hint: String,
    display: {
      type: String,
      default: 'select',
      validator: (prop:any) => [
        'select',
        'datepicker'
      ].includes(prop)
    },
    noIcon: {
      type: Boolean,
      default: false
    },
    showYear: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    offsetStartDate: {
      type: Boolean,
      default: false
    }
  },
  store
});

@Component
export default class DatePicker extends DatePickerProps {
  menu = false
  startPeriod = AvailableDates[0]
  date = this.getDate

  mounted (this:any) {
    if (store.state.pasture && store.state.pasture.simulation.date) {
		  this.startPeriod = AvailableDates.filter(x => x.start === dayjs(store.state.pasture!.simulation.date).format('D MMM'))[0];
    } else if (this.originalDate !== null) {
		  this.startPeriod = AvailableDates.filter(x => x.start === dayjs(this.originalDate).format('D MMM'))[0];
    } else {
      this.startPeriod = AvailableDates[0]
    }
  }

  get getDate () {
    return this.originalDate || this.dates[0]
  }

  get dates () {
    // This method will ensure that dates selected prior to the current date
    // will use the following year: e.g. if the date is 31-10-2021 and Jan 1
    // is selected than it will be formatted as 01-01-2022

    /*const currentDate = new Date()
    let dates = AvailableDates.map((ad) => {
      let year = currentDate.getFullYear();
      let date = cleanDate(ad.start, 'D MMM')
      if (date < currentDate) { year += 1 }
      return (year + '-' + dayjs(date).format('MM-DD'))
    })
    return dates*/

    // This method will ensure that all dates selected pertain to the 
    // current year: e.g. if the date is 31-10-2021 and Jan 1 is selected
    // than it will be formatted as 01-01-2021

    const year = (new Date()).getFullYear();
    return AvailableDates.map((ad) => `${year}-${dayjs(cleanDate(ad.start, 'D MMM'), 'D MMM').format('MM-DD')}`)
  }

  // If the offsetStartDate prop === true than selected dates will start from the simulation start date defined in
  // create simulation section of the pasture page
  get datesOffset () {
    let index = this.dates.map(d => dayjs(d).format('MM-DD')).indexOf(dayjs(this.startPeriod.start).format('MM-DD'))
    let offset:any[] = this.dates.map(d => {
      if (
        dayjs(d).format('MM-DD-YYYY') < dayjs(this.dates[index]).format('MM-DD-YYYY') ||
        dayjs(d).format('YYYY') < dayjs(this.dates[index]).format('YYYY')
      ) {
        return dayjs(d).add(1, 'year').format('YYYY-MM-DD')
      }
      return d
    })
    return offset.sort()
  }

  allowedDates (date:any) {
    return this.dates.indexOf(dayjs(date).format('YYYY-MM-DD')) !== -1
  }
}
